import { BackLinkedData, ItemWithOptions, LinkedSonID } from '@types'
import { Euler, Matrix4 } from 'three'

export default function getLinkedChildrenInfo(
  item: BackLinkedData,
  info: Record<string, Record<string, ItemWithOptions[]>>,
  idElementosEnlazados: number,
) {
  const {
    cantidad,
    descripcion,
    desenlazar,
    // idElementosEnlazados,
    posicionX,
    posicionY,
    posicionZ,
    rotacionX,
    rotacionY,
    rotacionZ,
  } = item

  let ordenVisual: number | null = null

  const parentNode = info?.[item.nodoPadre]
  if (parentNode) {
    const nodeKey = Object.keys(parentNode).find(
      (key) =>
        Array.isArray(parentNode[key]) &&
        parentNode[key].some((el: ItemWithOptions) => el.idUnidadEnlazada === idElementosEnlazados),
    )

    if (nodeKey) {
      const nodeOptions = parentNode[nodeKey]
      const foundItem = nodeOptions.find(
        (el: ItemWithOptions) => el.idUnidadEnlazada === idElementosEnlazados,
      )
      ordenVisual = foundItem?.ordenVisual ?? null
    }
  }

  const safePosicionX = posicionX ?? 0
  const safePosicionY = posicionY ?? 0
  const safePosicionZ = posicionZ ?? 0

  return {
    quantity: cantidad,
    code: item.unidad.codigo satisfies string,
    isUnlinkable: Boolean(desenlazar),
    linkedID: idElementosEnlazados,
    visualOrder: ordenVisual,
    option: item.nodo,
    parentOption: item.nodoPadre,
    description: descripcion,
    x: safePosicionX,
    y: safePosicionY,
    z: safePosicionZ,
    posicionX: safePosicionX,
    posicionY: safePosicionY,
    posicionZ: safePosicionZ,
    childs: new Set<LinkedSonID>(),
    matrix: new Matrix4()
      .makeRotationFromEuler(new Euler(rotacionX ?? 0, rotacionY ?? 0, rotacionZ ?? 0, 'XYZ'))
      .setPosition(safePosicionX, safePosicionY, safePosicionZ),
    typeOfSon: descripcion,
    referenciaBlender: (item.unidad as any)?.referenciaBlender ?? undefined,
  }
}
export type BaseLinkedChildrenInfo = ReturnType<typeof getLinkedChildrenInfo>
